/**
 * pricing.js — 纯函数模块，不算价 (A1)
 * 所有展示价格读 product.json，本模块只做 variant 路由 + combo 判定
 *
 * 依赖: window.StickerConfig.pricing (来自 config.js)
 * 加载顺序: config.js → pricing.js → app.js (app.js bootstrap 挂载到 StickerEngine)
 */
(function () {
  'use strict';

  var pricing = window.StickerConfig && window.StickerConfig.pricing;
  if (!pricing) {
    console.warn('StickerConfig.pricing not found — pricing module disabled');
    return;
  }

  /**
   * 解析 ribbon → tier multiplier (A2)
   * 例: ribbon 'silver-white' → 1.5
   */
  function getRibbonTierMultiplier(ribbon) {
    return pricing.ribbonMultiplier[ribbon] ?? 1.0;
  }

  /**
   * A3: effectiveMultiplier = ribbonMult × paperMult × shapeMult
   */
  function getEffectiveMultiplier(paper, ribbon, shape) {
    shape = shape || '2x2';
    var ribbonMult = pricing.ribbonMultiplier[ribbon] ?? 1.0;
    var paperMult  = pricing.paperMultiplier[paper]  ?? 1.0;
    var shapeMult  = pricing.shapeMultiplier[shape]  ?? 1.0;
    return ribbonMult * paperMult * shapeMult;
  }

  /**
   * A8: 给定 paper + ribbon + qty + variantMatrix, 返回对应 variantId
   * variantMatrix 来自 product.json (初始化时构建)
   * tierLabel: 若 ribbonMult <= 1.0 → "1.0", 否则 "1.5"
   */
  function resolveVariantId(paper, ribbon, qty, variantMatrix) {
    var ribbonMult = getRibbonTierMultiplier(ribbon);
    var tierLabel = ribbonMult <= 1.0 ? '1.0' : '1.5';
    // variantMatrix 结构: { [qty]: { '1.0': variantId, '1.5': variantId } }
    var tierBlock = variantMatrix[qty];
    if (!tierBlock) return null;
    return tierBlock[tierLabel] ?? null;
  }

  /**
   * A11: 判断 (paper, ribbon) 是否为禁用组合
   */
  function isComboDisabled(paper, ribbon) {
    return pricing.disabledCombos.some(function (pair) {
      return pair[0] === paper && pair[1] === ribbon;
    });
  }

  /**
   * 返回某 paper 下被禁用的 ribbon 列表 (用于 grey out)
   */
  function getDisabledRibbonsForPaper(paper) {
    return pricing.disabledCombos
      .filter(function (pair) { return pair[0] === paper; })
      .map(function (pair) { return pair[1]; });
  }

  /**
   * 返回某 ribbon 下被禁用的 paper 列表
   */
  function getDisabledPapersForRibbon(ribbon) {
    return pricing.disabledCombos
      .filter(function (pair) { return pair[1] === ribbon; })
      .map(function (pair) { return pair[0]; });
  }

  // ── 导出到 StickerEngine ──
  window.StickerEngine = window.StickerEngine || {};
  window.StickerEngine.getRibbonTierMultiplier = getRibbonTierMultiplier;
  window.StickerEngine.getEffectiveMultiplier   = getEffectiveMultiplier;
  window.StickerEngine.resolveVariantId         = resolveVariantId;
  window.StickerEngine.isComboDisabled          = isComboDisabled;
  window.StickerEngine.getDisabledRibbonsForPaper = getDisabledRibbonsForPaper;
  window.StickerEngine.getDisabledPapersForRibbon = getDisabledPapersForRibbon;

})();
